import { errorMessageFrom } from "../../../../../../../utils/formErrors";
import React, {useState} from 'react';
import TopBar from '../../../../../../../component/TopBar';
import {Box, CircularProgress, Stack, Select, MenuItem} from '@mui/material';
import ActiveBar from '../../../../../../../component/PolicyNavbarUpdated';
import BtnSecondary from "../../../../../../../component/SecondaryButton";
import BtnPrimary from "../../../../../../../component/PrimaryButton";
import ErrorMsg from '../../../../../../../component/ErrorMsg';
import FormField from '../../../../../../../component/Formfield';
import { WizardCard, FormSection, FieldGrid, FieldLabel, SwitchRow, WizardActions } from '../../../../../../../component/wizard';
import GeofenceField from './GeofenceField';
import { tokens } from '../../../../../../../theme';
import { useNavigate } from 'react-router';
import DateField from '../../../../../../../component/DateField';
import { createAttendancePolicy } from '../../../../../../../services/attendancePolicy';
import { useNotify } from '../../../../../../../component/NotificationProvider';

const AttendancePolicyDetails = () => {
    const [apiCall,setApiCall]=useState(false);
    const navigate = useNavigate();
    const notify = useNotify();
    const [policyData,setPolicyData] = useState({
          code:"",
          name:"",
          startDate:null,
          endDate:null,
     //   workMode:"Work from office",
          allowMobileClockIn:false,
          enableGeofencing:false,
          geofenceMode:"block",
          geofenceToleranceMeters:50,
          requireCommentMobileClockIn:false,
          allowWebClockIn:false,
          requireCommentWebClockIn:false,
          gracePeriodMinutes:0,
          punchRoundingMinutes:0,
          roundingDirection:"nearest",
          regularization:{maxPerMonth:0, windowDays:0, requiresApproval:true},
          missedCheckoutPolicy:"flag",
          status:"draft", // stays a draft through the wizard; published on the Review step

     //   isApprovalMandatoryMobile:false,
     //   isApprovalMandatoryWeb:false,
    });
    
    const [startDateDialogOpen, setStartDateDialogOpen] = useState(false);
    const [endDateDialogOpen, setEndDateDialogOpen] = useState(false);
    const [validationErrors, setValidationErrors] = useState({code:"",
                                                              name:"",
                                                              startDate:"",
                                                              endDate:"",
                                                            });
   const [error,setError]=useState("");
  
   const handleNextClick = async() => {
        const errors ={};
  
        if (!policyData.code) errors.code="Code is required"
        if (!policyData.name) errors.name="Name is required"
        if (!policyData.startDate) errors.startDate="Start Date is required"
        if (!policyData.endDate) errors.endDate="End Date is required"
        
        if (Object.keys(errors).length > 0) {
          setValidationErrors(errors);
          return;
        }
  
        setApiCall(true);
        try {
          const res = await createAttendancePolicy(policyData);
          if(res.success){
            notify.success("Attendance policy created");
            navigate("/app/attendance-policy/new/add-category",{state:{policyId: res?.data._id}});
          } else {
              setError(res.message);
              notify.error(errorMessageFrom(res, "Policy creation failed"));
          }
        } catch (error) {
            notify.error(error?.message || "Something went wrong creating the policy");
        } finally {
            setApiCall(false);
        }
    };
  
    const handleChange = (field, value) => {
      const updatedValue = field === "code" ? value?.toUpperCase() : value;
      setPolicyData(prevState => ({...prevState, [field]: updatedValue}));
      setValidationErrors(prevState => ({...prevState, [field]: ""}));
      setError("");
    };
  
  return (
    <Box sx={{width:"100%"}}>
        <TopBar
          MainHeading={"Attendance Policy"}
          breadcrumbs={[{label:"Attendance", href:""},{label:"Policy Details", href:""}]}
        />
        <WizardCard>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
                <ActiveBar active={["Policy Details"]} />
                <BtnSecondary to={"/app/attendance-policy/listing"} sx={{ borderRadius: "8px" }}>
                    Back
                </BtnSecondary>
            </Stack>

            <FormSection title="Policy details" description="Name the policy and set the period it applies for.">
                <FieldGrid>
                    <Box>
                        <FieldLabel required>Policy Code</FieldLabel>
                        <FormField type="text" value={policyData.code} validation={validationErrors.code}
                            placeholder="e.g. E099" onChange={(e) => handleChange('code', e.target.value)} />
                    </Box>
                    <Box>
                        <FieldLabel required>Policy Name</FieldLabel>
                        <FormField type="text" value={policyData.name} validation={validationErrors.name}
                            onChange={(e) => handleChange('name', e.target.value)} />
                    </Box>
                    <Box>
                        <FieldLabel required>Policy Start Date</FieldLabel>
                        <DateField value={policyData.startDate} isDialogOpen={startDateDialogOpen} validation={validationErrors.startDate}
                            openDialog={() => setStartDateDialogOpen(true)} closeDialog={() => setStartDateDialogOpen(false)}
                            onSelect={(date) => { handleChange('startDate', date); setStartDateDialogOpen(false); }} />
                    </Box>
                    <Box>
                        <FieldLabel required>Policy End Date</FieldLabel>
                        <DateField value={policyData.endDate} isDialogOpen={endDateDialogOpen} validation={validationErrors.endDate}
                            openDialog={() => setEndDateDialogOpen(true)} closeDialog={() => setEndDateDialogOpen(false)}
                            onSelect={(date) => { handleChange('endDate', date); setEndDateDialogOpen(false); }} />
                    </Box>
                </FieldGrid>
            </FormSection>

            <FormSection title="Mobile clock-in" description="How employees clock in from the mobile app.">
                <SwitchRow title="Allow mobile clock-in" description="Employees can mark attendance from their phone."
                    checked={policyData?.allowMobileClockIn} onChange={(e)=>handleChange('allowMobileClockIn',e.target.checked)} />
                <SwitchRow title="Enable geo-fencing" description="Restrict clock-in to within the office geofence."
                    checked={policyData.enableGeofencing} disabled={!policyData?.allowMobileClockIn}
                    onChange={(e)=>handleChange('enableGeofencing',e.target.checked)} />
                {policyData.enableGeofencing && policyData.allowMobileClockIn && (
                  <>
                    <GeofenceField />
                    <FieldGrid>
                      <Box>
                        <FieldLabel>Enforcement mode</FieldLabel>
                        <Select size="small" fullWidth value={policyData.geofenceMode || "block"}
                          onChange={(e)=>handleChange('geofenceMode',e.target.value)}>
                          <MenuItem value="block">Block — reject clock-in outside the geofence</MenuItem>
                          <MenuItem value="monitor">Monitor — allow but flag for regularization</MenuItem>
                        </Select>
                      </Box>
                      <Box>
                        <FieldLabel>GPS tolerance (metres)</FieldLabel>
                        <FormField type="number" value={policyData.geofenceToleranceMeters ?? 50} noMargin height="2.75rem"
                          onChange={(e)=>handleChange('geofenceToleranceMeters', e.target.value === "" ? "" : Number(e.target.value))} />
                      </Box>
                    </FieldGrid>
                  </>
                )}
                <SwitchRow title="Comment required at clock-in" description="Ask for a note when marking attendance."
                    checked={policyData.requireCommentMobileClockIn} disabled={!policyData?.allowMobileClockIn}
                    onChange={(e)=>handleChange('requireCommentMobileClockIn',e.target.checked)} />
            </FormSection>

            <FormSection title="Web clock-in" description="How employees clock in from the web app.">
                <SwitchRow title="Allow web clock-in" description="Employees can mark attendance from the browser."
                    checked={policyData?.allowWebClockIn} onChange={(e)=>handleChange("allowWebClockIn",e.target.checked)} />
                <SwitchRow title="Comment required at clock-in" description="Ask for a note when marking attendance."
                    checked={policyData.requireCommentWebClockIn} disabled={!policyData?.allowWebClockIn}
                    onChange={(e)=>handleChange('requireCommentWebClockIn',e.target.checked)} />
            </FormSection>

            <FormSection title="Timing rules" description="Grace buffer before a punch counts as late, and optional punch rounding.">
                <FieldGrid>
                    <Box>
                        <FieldLabel>Grace period (minutes)</FieldLabel>
                        <FormField type="number" value={policyData.gracePeriodMinutes ?? 0} noMargin height="2.75rem"
                            onChange={(e)=>handleChange('gracePeriodMinutes', e.target.value === "" ? "" : Number(e.target.value))} />
                    </Box>
                    <Box>
                        <FieldLabel>Punch rounding</FieldLabel>
                        <Select size="small" fullWidth value={policyData.punchRoundingMinutes ?? 0}
                            onChange={(e)=>handleChange('punchRoundingMinutes', Number(e.target.value))}>
                            <MenuItem value={0}>No rounding</MenuItem>
                            <MenuItem value={5}>Nearest 5 min</MenuItem>
                            <MenuItem value={10}>Nearest 10 min</MenuItem>
                            <MenuItem value={15}>Nearest 15 min</MenuItem>
                        </Select>
                    </Box>
                    {Number(policyData.punchRoundingMinutes) > 0 && (
                        <Box>
                            <FieldLabel>Rounding direction</FieldLabel>
                            <Select size="small" fullWidth value={policyData.roundingDirection || "nearest"}
                                onChange={(e)=>handleChange('roundingDirection', e.target.value)}>
                                <MenuItem value="nearest">Nearest</MenuItem>
                                <MenuItem value="up">Round up (favour employee on out, stricter on in)</MenuItem>
                                <MenuItem value="down">Round down</MenuItem>
                            </Select>
                        </Box>
                    )}
                </FieldGrid>
            </FormSection>

            <FormSection title="Regularization &amp; missed punches" description="Correction limits and how to handle a missing check-out.">
                <SwitchRow title="Require approval for regularization" description="Off = trusted employees' corrections apply immediately."
                    checked={policyData.regularization?.requiresApproval !== false}
                    onChange={(e)=>handleChange('regularization', { ...policyData.regularization, requiresApproval: e.target.checked })} />
                <FieldGrid>
                    <Box>
                        <FieldLabel>Max regularizations / month</FieldLabel>
                        <FormField type="number" value={policyData.regularization?.maxPerMonth ?? 0} noMargin height="2.75rem"
                            onChange={(e)=>handleChange('regularization', { ...policyData.regularization, maxPerMonth: e.target.value === "" ? 0 : Number(e.target.value) })} />
                    </Box>
                    <Box>
                        <FieldLabel>Regularization window (days back)</FieldLabel>
                        <FormField type="number" value={policyData.regularization?.windowDays ?? 0} noMargin height="2.75rem"
                            onChange={(e)=>handleChange('regularization', { ...policyData.regularization, windowDays: e.target.value === "" ? 0 : Number(e.target.value) })} />
                    </Box>
                    <Box>
                        <FieldLabel>Missing check-out</FieldLabel>
                        <Select size="small" fullWidth value={policyData.missedCheckoutPolicy || "flag"}
                            onChange={(e)=>handleChange('missedCheckoutPolicy', e.target.value)}>
                            <MenuItem value="flag">Flag for review</MenuItem>
                            <MenuItem value="autoCloseAtShiftEnd">Auto-close at shift end</MenuItem>
                            <MenuItem value="none">Ignore</MenuItem>
                        </Select>
                    </Box>
                </FieldGrid>
                <Box sx={{ fontSize: "0.8125rem", color: tokens.textMuted, mt: "0.25rem" }}>0 = unlimited / no window limit.</Box>
            </FormSection>

            <ErrorMsg>{error}</ErrorMsg>
            <WizardActions>
                <BtnPrimary
                    onClick={handleNextClick}
                    sx={{ height: "3rem", px: "2.5rem", borderRadius: "10px" }}
                    disabled={apiCall}
                >
                    {apiCall?<CircularProgress size={"1.25rem"}/>:"Next"}
                </BtnPrimary>
            </WizardActions>
        </WizardCard>
    </Box>
    )
}

export default AttendancePolicyDetails;